export const getMedia = async (id: string) => {
    const response = await fetch(`https://interprika.com/cms/wp-json/wp/v2/media/${id}`);
    const data = await response.json();
    return data.source_url;
};